exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-029b8bd8]{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p[data-v-029b8bd8]{margin-bottom:12px}ol[data-v-029b8bd8]{list-style:inside}.toc[data-v-029b8bd8]{position:relative;left:0;padding:72px 100px 150px;box-sizing:border-box;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}@media (max-width:440px){.toc[data-v-029b8bd8]{padding:72px 15px 50px}}.toc-headline[data-v-029b8bd8]{font-family:LabilGrotesk;font-size:34px;font-weight:700;line-height:36px;font-size:50px;line-height:53px;margin-bottom:50px}.toc-indexes[data-v-029b8bd8]{display:flex;flex-flow:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-029b8bd8","scoped":true,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/combinedBlocks/Toc.vue
// module id = 507
// module chunks = 0